<template lang="pug">
  // TABLE that displays CRM
  div
    p(v-if='loading')
    app-table(:data='tableItems', :label='tableFields', sortBy='numTimestamp', :sortDesc='true', v-else)
</template>

<script>
import { db } from '@/firebase'
// import numeral from 'numeral'

const customRef = db.ref('custom')

export default {
  name: 'crm-table-tm',
  data() {
    return {
      cls: {},
      loading: true,
      userAccessLevel: this.$store.state.profile.accessLevel,
      tableItems: [
      ],
      tableFields: {
        name: {
          label: 'Client Name',
        },
        nric: {
          label: 'Company',
        },
        message: {
          label: 'Phone No.',
        },
        numTimestamp: {
          label: 'Submitted on',
          sortable: true,
        },
        statusString: {
          label: '<i></i>',
          class: 'text-right',
          thStyle: {
            minWidth: '25em',
          },
        },
      },
    }
  },
  mounted: function() {
    var customs
    const self = this
    customRef.child('appt').on('value', (snapshot) => {
      customs = []
      Object.entries(snapshot.val()).forEach(
        function([key, val]) {
          var address = val.address ? ('https://www.google.com/maps/search/?api=1&query=' + val.address.replace(/ /g, '%20').replace(/,/g, '%2C')) : ''
          customs.unshift({
            avatar: { url: val.profilePic, tooltip: key },
            name: val.name,
            intent: val.cusSerial,
            message: val.phone,
            nric: val.company,
            audience: '',
            // audience: self.extractFromObject(val.location.locationObj.address_components, 'locality'),
            numTimestamp: parseInt(val.timestamp),
            statusString: { formUrl: 'null', mapUrl: address, carUrl: 'null', imageUrl: val.imageUrl, btn1: 'Followed Up', btn2: 'Email', btn3: 'Make Remark', email: 'null', id: key, crm: 'appt', resolved: val.resolved, userAccessLevel: self.userAccessLevel, remark: val.remark },
            _rowVariant: val.resolved && 'success',
          })
        })
      // console.log(customs)
      this.tableItems = customs
      this.loading = false
    })
  },
  methods: {
    extractFromObject (object, key) {
      return object.filter((component) => component.types.indexOf(key) === 0).map((item) => item.long_name).pop() || null
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/fragments/crmTableTM.vue?0d9621dc